const getters = {
  sidebar: state => state.app.sidebar,
  tempMenu: state => state.app.tempMenu,
  oss_base_url: state => state.app.oss_base_url,
  visitedViews: state => state.tagsView.visitedViews,
  activeMenuId: state => state.tagsView.activeMenuId,
  cachedViews: state => state.tagsView.cachedViews,
  errorLogs: state => state.errorLog.logs,
  isLoading: state => state.loading.loadingList.length > 0,
  loadingText: state => (state.loading.loadingList.length > 0 ? state.loading.loadingList[0].text : null),
  user: state => state.user,
  msgObj: state => state.msg,
  isShow: state => state.msg.isShow
};
export default getters;
